<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="F. Analiza SWOT"
                warn="Această secțiune trebuie să prezinte punctele tari și punctele slabe (interne) și oportunitățile și amenințările (externe) cu care se confruntă organizația."
            >
                <template v-slot:body>
                    <div class="swot-header">
                        <div class="benefice">
                            <span>Benefice atingerii obiectivelor</span>
                        </div>
                        <div class="pericol">
                            <span>Pun în pericol atingerea obiectivelor</span>
                        </div>
                    </div>
                    <div class="swot-body">
                        <div class="swot-left">
                            <p><span>Sursă internă</span></p>
                            <p><span>Sursă externă</span></p>
                        </div>
                        <div class="swot-content">
                            <div class="gray-box textarea">
                                <p>Puncte tari</p>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="form.strength"
                                        rows="20"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.strength.length)"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                            <div class="gray-box textarea">
                                <p>Puncte slabe</p>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="form.weakness"
                                        rows="20"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.weakness.length)"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                            <div class="gray-box textarea">
                                <p>Oportunități</p>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="form.opportunities"
                                        rows="20"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.opportunities.length)"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                            <div class="gray-box textarea">
                                <p>Amenințări</p>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-textarea
                                        v-model="form.threat"
                                        rows="20"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.threat.length)"
                                    ></b-form-textarea>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                        </div>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider, ValidationObserver
        },
        props: {
            swot: null
        },
        data() {
            return {
                completed: null,
                form: {
                    strength: null,
                    weakness: null,
                    opportunities: null,
                    threat: null,
                }
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriAnalizaSwot;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            swot: {
                handler () {
                    if(this.swot){
                        this.form.strength = this.swot.business_plan_swot.strength ? this.swot.business_plan_swot.strength : ''
                        this.form.weakness = this.swot.business_plan_swot.weakness ? this.swot.business_plan_swot.weakness : ''
                        this.form.opportunities = this.swot.business_plan_swot.opportunities ? this.swot.business_plan_swot.opportunities : ''
                        this.form.threat = this.swot.business_plan_swot.threat ? this.swot.business_plan_swot.threat : ''
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.swot){
                this.form.strength = this.swot.business_plan_swot.strength ? this.swot.business_plan_swot.strength : ''
                this.form.weakness = this.swot.business_plan_swot.weakness ? this.swot.business_plan_swot.weakness : ''
                this.form.opportunities = this.swot.business_plan_swot.opportunities ? this.swot.business_plan_swot.opportunities : ''
                this.form.threat = this.swot.business_plan_swot.threat ? this.swot.business_plan_swot.threat : ''
            }
            if(!this.form.strength){
                this.form.strength = 'Resurse umane specializate, competente în gestionarea fondurilor\n' +
                    '\n' +
                    'Resursele materiale, financiare, informaționale de care dispune întreprinderea\n' +
                    '\n' +
                    'Capacitatea de creșterea a productivității în perioada de sustenabilitate\n' +
                    '\n' +
                    'Finanțarea REACT-EU (POC 4.1.1)\n' +
                    '\n' +
                    'Proximitatea pieţelor europene\n' +
                    '\n' +
                    'Concentrarea investiţiei în jurul oraşului Bucureşti (regiunile BI, SE, SM), cu efecte de creştere a productivitatii si vanzari în zonele învecinate\n' +
                    '\n' +
                    'Vechimea si notorietatea companiei\n' +
                    '\n' +
                    'Calitatea produselor  / serviciilor'
            }

            if(!this.form.weakness){
                this.form.weakness = 'Identificare dificilă a furnizorilor potriviți\n' +
                    '\n' +
                    'Finanțare insuficientă pentru publicitate și promovare\n' +
                    '\n' +
                    'Digitalizare slaba\n' +
                    '\n' +
                    'Inexistenta unui sistem ISO\n' +
                    ' \n' +
                    'Infrastructura neadecvata\n' +
                    '\n' +
                    'Deteriorarea continua a pozitiei competitive'
            }

            if(!this.form.opportunities){
                this.form.opportunities = 'Preocuparea autorităților pentru stimularea dezvoltării IMM-urilor\n' +
                    '\n' +
                    'Posibilitatea de a încheia parteneriate, colaborări, apartenența la o rețea\n' +
                    '\n' +
                    'Nevoia pe piața de produse pe care întreprinderea le dezvoltă este în continuă creștere\n' +
                    '\n' +
                    'Accesarea finantarilor nerambursabile\n' +
                    '\n' +
                    'Tranziţia către o economie bazată pe servicii\n' +
                    '\n' +
                    'Cresterea rapida a pietei \n' +
                    '\n' +
                    'Posibilitatea de extindere a nomenclatorului de produse si/sau servicii'
            }

            if(!this.form.threat){
                this.form.threat = 'Forță de muncă specializată în domeniu redusă\n' +
                    '\n' +
                    'Ofertă limitată la momentul actual de echipamente sustenabile pentru mediu\n' +
                    '\n' +
                    'Continuarea și chiar amplificarea pandemiei\n' +
                    '\n' +
                    'Fenomene meteorologice extreme (în cazul construcțiilor)\n' +
                    '\n' +
                    'Migratia fortei de munca\n' +
                    '\n' +
                    'Adoptarea unor reglementari legislative sau normative restrictive cu impact nefavorabil\n' +
                    '\n' +
                    'Intrarea intr-o perioada de recesiune economica la nivel national sau international\n' +
                    '\n' +
                    'Schimbari ale nevoilor, gusturilor sau preferintelor clientilor\n' +
                    '\n' +
                    'Crestere mai lenta, stagnare sau chiar recesiune a pietei\n' +
                    '\n' +
                    'Intrarea unor noi competitori pe piata'
            }

        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{

                        this.formSend = {
                            business_plan_swot: {
                                business_plan_swot: this.form,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriAnalizaSwot !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriAnalizaSwot', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}

.swot-content{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}
.gray-box{
    min-height: 280px;
    width: 49.3%;
    background: #f8f9f9;
    padding: 20px;
}

.swot-header{
    display: flex;
    margin-left: 47px;
    max-width: 95.5%;
    justify-content: space-between;
    margin-bottom: 10px;
    gap:10px;
}
.benefice, .pericol{
    width: 50%;
    padding: 5px 10px;
    font-weight: 700;
    text-align: center;
}
.benefice{
    background: #a7fff2;
}
.pericol{
    background: #ff8888;
    color: #fff;
}
.swot-left{
    max-height: 100%;
}
.swot-body{
    display: flex;
}
.swot-content p{
    font-size: 18px;
    font-weight: 700;
    color: #515679;
}
.swot-content textarea{
    height: 90%;
}
.swot-left p{
    background: #f8f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    height: 50%;
    margin: 0 10px;
}
.swot-left p span{
    transform: rotate(-180deg);
    writing-mode: vertical-rl;
}
@media (max-width: 1600px){
    .gray-box{
        width: 49%;
        min-width: inherit;
    }
    .pericol, .benefice{
        width: 49%;
        min-width: inherit;
    }
}
@media (max-width: 1400px){
    .gray-box{
        width: 49%;
        min-width: inherit;
    }
    .pericol, .benefice{
        width: 49.3%;
        min-width: inherit;
    }
}
@media screen and (max-width: 1367px) {
    .swot-header {
        max-width: 94.5%;
    }
}
@media screen and (max-width: 1281px) {
    .swot-header {
        max-width: 94%;
    }
}
@media screen and (min-width: 2100px) {
    .swot-header {
        max-width: 96.5%;
    }
}
@media screen and (min-width: 3840px) {
    .swot-header {
        max-width: 97.5%;
    }
}
</style>
